module.exports = __webpack_public_path__ + "img/strategy.ac8809fa.svg";